(() => {
  if (customElements.get('tube-size-finder')) return;

  class TubeSizeFinder extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      if (
        event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      ) return;

      const link = event.target.closest('a[data-tube-size-value]');
      if (
        !link || link.closest('tube-size-finder') !== this ||
        !link.hasAttribute('href') || link.hasAttribute('download') ||
        (link.target && link.target !== '_self')
      ) return;

      const param = this.dataset.filterParam;
      const value = link.dataset.tubeSizeValue;
      const section = this.closest('[data-section-type="collection"]');
      const form = section?.querySelector('#desktop-filters-form');
      if (!param || !form) return;

      const inputs = Array.from(form.querySelectorAll('input[type="checkbox"]'))
        .filter(input => input.name === param);
      const selected = value === '' ? null : inputs.find(input => input.value === value);

      // A real href remains the fallback if Shopify did not render this filter.
      if (!inputs.length || (value !== '' && (!selected || selected.disabled))) return;

      const changed = inputs.filter(input => input.checked !== (input === selected));
      if (!changed.length) {
        event.preventDefault();
        return;
      }

      inputs.forEach(input => {
        input.checked = input === selected;
      });

      // Only this size facet changes. The native form retains price, brand and sort.
      // Its delegated change handler owns AJAX, pagination reset and browser history.
      const previousUrl = window.location.href;
      (selected || changed[0]).dispatchEvent(new Event('change', { bubbles: true }));

      // The theme updates history synchronously. If its handler is unavailable,
      // keep the link's normal navigation rather than swallowing the click.
      if (window.location.href !== previousUrl) event.preventDefault();
    }
  }

  customElements.define('tube-size-finder', TubeSizeFinder);
})();
